module.exports = "https://cdn-assessment.mathletics.com/app/122/assets/fonts/9bd029da4737382f43eec132079fddce.woff2";